import React, { memo } from 'react';
import ApiSelect from './ApiSelect';
import { Filter, X } from 'lucide-react';

const ReportFilterSection = memo(({
  filters,
  onCompanySelect,
  onPartySelect,
  onClearFilters
}) => {
  return (
    <div className="bg-white rounded-2xl border border-brand-100 p-3 sm:p-4">
      <div className="space-y-3 sm:space-y-0 sm:flex sm:flex-wrap sm:items-center sm:gap-3">
        <div className="flex items-center gap-1.5 text-gray-400">
          <Filter className="w-4 h-4" />
          <span className="text-sm font-medium">Filters</span>
        </div>

        <div className="w-full sm:flex-1 sm:min-w-0">
          <ApiSelect
            type="companies"
            value={filters.company ? filters.company._id : null}
            onChange={onCompanySelect}
            placeholder="Company"
            isClearable={true}
          />
        </div>

        <div className="w-full sm:flex-1 sm:min-w-0">
          <ApiSelect
            type="parties"
            value={filters.party ? filters.party._id : null}
            onChange={onPartySelect}
            placeholder="Party"
            isClearable={true}
          />
        </div>

        <button
          onClick={onClearFilters}
          className="w-full sm:w-auto flex items-center justify-center gap-1.5 bg-brand-50 text-brand-600 px-3 py-2 rounded-xl hover:bg-brand-100 transition-colors text-sm font-medium"
        >
          <X className="w-3.5 h-3.5" />
          Clear
        </button>
      </div>
    </div>
  );
});

ReportFilterSection.displayName = 'ReportFilterSection';

export default ReportFilterSection;
